import { Component, inject, signal, computed, input, output, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe, TranslationService } from '@nebula-shared/data-access';
import { TableConfig } from 'nebula-ui-kit';
import {
  CuentaContableItem,
  FormatoContableDetalle,
  AccountingAccountPopupData,
} from '../../domain/accounting-account.model';
import { DataTableWrapperComponent } from '../../../../../../ui/src/lib/data-table-wrapper/data-table-wrapper.component';

export type { CuentaContableItem, FormatoContableDetalle, AccountingAccountPopupData };

@Component({
  selector: 'app-accounting-account-popup',
  templateUrl: './accounting-account-popup.component.html',
  styleUrls: ['./accounting-account-popup.component.scss'],
  standalone: true,
  imports: [CommonModule, DataTableWrapperComponent, TranslatePipe],
})
export class AccountingAccountPopupComponent {
  private readonly translation = inject(TranslationService);

  popupData = input<AccountingAccountPopupData>({
    formato: null,
    loading: false,
    error: null,
  });

  closed = output<void>();

  loading = signal<boolean>(false);
  error = signal<string | null>(null);
  formato = signal<FormatoContableDetalle | null>(null);

  constructor() {
    effect(() => {
      const data = this.popupData();
      this.loading.set(data.loading ?? false);
      this.error.set(data.error ?? null);
      this.formato.set(data.formato ?? null);
    });
  }

  cuentasContablesTableConfig = computed<TableConfig<CuentaContableItem>>(() => ({
    columns: [
      {
        key: 'tipoCentroCostoNombre',
        label: this.translate('ACCOUNTING.COST_CENTER.LABEL.COST_CENTER_TYPE_LABEL'),
        sortable: false,
        width: '15%',
        align: 'left',
      },
      {
        key: 'cuentaDebitoCodigo',
        label: this.translate('ACCOUNTING.ACCOUNT_CONFIGURATION.TABLE.COLUMN.DEBIT'),
        sortable: false,
        width: '12%',
      },
      {
        key: 'cuentaDebitoNombre',
        label: this.translate('ACCOUNTING.ACCOUNTING_FORMAT.LABEL.NAME'),
        sortable: false,
        width: '20%',
      },
      {
        key: 'cuentaCreditoCodigo',
        label: this.translate('ACCOUNTING.ACCOUNT_CONFIGURATION.TABLE.COLUMN.CREDIT'),
        sortable: false,
        width: '12%',
      },
      {
        key: 'cuentaCreditoNombre',
        label: this.translate('ACCOUNTING.ACCOUNTING_FORMAT.LABEL.NAME'),
        sortable: false,
        width: '20%',
      },
      {
        key: 'cuentaIvaCodigo',
        label: this.translate('ACCOUNTING.ACCOUNT_CONFIGURATION.TABLE.COLUMN.VAT'),
        sortable: false,
        width: '11%',
      },
    ],
    showPagination: false,
    actions: [],
  }));

  formattedCuentasContables = computed(() => {
    const cuentas = this.formato()?.cuentasContables || [];
    return cuentas.map((cuenta) => ({
      ...cuenta,
      cuentaIvaCodigo: cuenta.cuentaIvaId ? cuenta.cuentaIvaId.toString() : '-',
      codigoBancoDebito: cuenta.codigoBancoDebito || '-',
    }));
  });

  onClose(): void {
    this.closed.emit();
  }

  protected translate(key: string, params?: Record<string, string | number>): string {
    return this.translation.translate(key, params);
  }
}
